import React, { useEffect, useRef } from "react";
import { runtime, Util } from "codeArt/common";
import ReactEcharts from "echarts-for-react";
import { theme } from "codeArt/components/Base";
import * as echarts from "echarts";
import { depleteId } from "app/routes/analysis/routes/cost/constant";

export default class AreaChart extends React.Component {
  constructor(props) {
    super(props);
  }

  format(params) {
    let { data } = this.props;
    let { x, y } = data;
    let name = params.seriesName;
    let value = params.data;
    let marker = params.marker;

    let item =
      y.find(t => {
        return t.name == name;
      }) || {};
    if (Util.empty(item)) item = y[0] || {};

    value = item.format ? item.format(value) : value; //自定义显示数据格式
    let e = name.indexOf("series") > -1;

    if (e) return { marker, value };
    else return { marker, value, name };
  }

  handle(v) {
    let axis = { ...v };
    let format = v.format;
    let label = v.label;
    delete axis.format;
    delete axis.label;
    return { axis: axis, format: format, label: label };
  }

  getYMax() {
    let { data, y: yAxis } = this.props;
    let { y } = data;
    let interval = yAxis.interval || 1;

    let temp = y.map(({ data }) => Util.max(data));
    let maxValue = Util.max(temp);

    if (interval <= 1) return maxValue;

    //将y的最大值对齐interval
    let multiple = parseInt(maxValue / interval);
    if (maxValue % interval > 0) multiple++;
    return interval * multiple;
  }

  getOption() {
    let {
      data,
      y: yAxis,
      x: xAxis,
      xAxisInterval,
      markArea,
      title,
      tooltip,
      legend,
      legendTop,
      stack,
      symbolSize,
      area,
      line,
      lineStyle,
      grid,
      label,
      titleStyle,
      animation,
      linearGradient,
      smooth,
      lineColor
    } = this.props;
    let { x, y } = data;
    let option = {};
    let my = this;
    if (title) {
      option.title = {
        text: title,
        textStyle: {
          fontSize: 16,
          fontWeight: 400,
          color: theme.color.dark,
          ...titleStyle
        }
      };
    }

    if (tooltip) {
      option.tooltip = {
        trigger: "axis",
        formatter: function(params) {
          let tip = `${params[0].name}<br/>`;

          for (let i = 0; i < params.length; i++) {
            var data = my.format(params[i]);
            if (data.name)
              tip += `${data.marker} ${data.name} : ${data.value}<br/>`;
            else tip += `${data.marker} ${data.value}<br/>`;
          }

          return tip;
        }
      };
    }

    if (legend) {
      // 是否显示图标上方类型按钮
      let ldata = y.map((t, i) => {
        return t.name;
      });
      option.legend = { data: ldata };
      if (legendTop) option.legend.top = 0;
      else option.legend.bottom = 0;
    }

    option.grid = { left: "10", right: "25", containLabel: true }; //自定义图表两边留空
    option.grid = Object.assign(option.grid, grid);

    let xParams = my.handle(xAxis);
    option.xAxis = {
      type: "category",
      boundaryGap: x.boundaryGap, //折线图的两边预留位
      data: x,
      axisLabel: {
        formatter: function(value) {
          return xParams.format ? xParams.format(value) : value;
        },
        interval: xAxisInterval, // 为0时，使x轴横坐标全部显示，大于0按照输入的数值缩略显示x轴横坐标
        ...xParams.label
      },
      ...xParams.axis
    };

    let yParams = my.handle(yAxis);
    option.yAxis = {
      type: "value",
      splitLine: { show: line, lineStyle: { color: lineColor, ...lineStyle } }, //网格线是否显示
      axisLabel: {
        formatter: function(value) {
          return yParams.format ? yParams.format(value) : value;
        },
        ...yParams.label
      },
      max: this.getYMax(),
      ...yParams.axis
    };

    let series = y.map((t, i) => {
      let serie = {
        name: t.name,
        type: "line",
        symbol: "circle",
        symbolSize: symbolSize || 2,
        sampling: "average",
        color: t.color,
        data: t.data,
        label: !label
          ? null
          : {
              show: true,
              backgroundColor: "transparent",
              formatter: function(p) {
                var data = my.format(p);
                return data.value;
              },
              ...label
            }
      };

      serie.itemStyle = {
        color: t.color
      };

      if (t.colorFormat) {
        serie.itemStyle = {
          normal: {
            color: v => {
              return t.colorFormat(v, t.color);
            },
            lineStyle: {
              color: v => {
                return t.colorFormat(v, t.color);
              }
            }
          }
        };
      }

      serie.smooth = smooth; //曲线折线设置

      if (markArea) serie.markArea = markArea;

      if (area)
        serie.areaStyle = {
          color: !linearGradient
            ? t.areaColor || t.color
            : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  //渐变效果设置
                  offset: 0,
                  color: t.areaColor || t.color
                },
                {
                  offset: 1,
                  color: "#ffe"
                }
              ])
        };

      if (stack) serie.stack = "stack"; //堆叠效果，AB两折线A折线会叠加在B折线上面，即使数据交叉，折线也不会进行交叉显示只会A数据叠加上B数据上显示
      return serie;
    });

    option.animation = animation; //动画
    option.series = series;
    return option;
  }

  getEvents() {
    let { onClick } = this.props;
    if (!onClick) return {};
    return { click: onClick };
  }

  render() {
    return (
      <ReactEcharts
        option={this.getOption()}
        notMerge={true}
        lazyUpdate={true}
        className={"w-100 h-100"}
        onEvents={this.getEvents()}
      />
    );
  }
}

AreaChart.defaultProps = {
  title: "",
  grid: {},
  smooth: false,
  tooltip: true,
  legend: true,
  legendTop: true,
  area: true,
  line: false,
  toolbox: false,
  stack: false,
  y: {},
  x: { boundaryGap: true },
  animation: true,
  linearGradient: true,
  xAxisInterval: 0,
  lineColor: "#f0f0f0"
};

AreaChart.propTypes = {};

/* let chart = null;

const AreaChart_M = (props) => {

    const ref = React.useRef(null)


    useEffect(() => {
        let { metadata,x, y, padding, getColor, data } = props;

        if (!chart) {
            chart = new F2.Chart({
                id: ref.current,
                pixelRatio: window.devicePixelRatio,
                padding: padding || "auto",
            });
        }

        chart.source(data);


        chart.tooltip({
            showCrosshairs: true,
            custom: true,
            onChange: function onChange(obj) {
                const legend = chart.get('legendController').legends.top[0];
                const tooltipItems = obj.items;
                const legendItems = legend.items;
                const map = {};
                legendItems.forEach(function (item) {
                    map[item.name] = _.clone(item);
                });
                tooltipItems.forEach(function (item) {
                    const name = item.name;
                    const value = item.value;
                    if (map[name]) {
                        let item = y.items.find((t) => { return t.type == name; })
                        map[name].value = item.format ? item.format(value) : value;
                    }
                });


                legend.setItems(_.values(map));
            },
            onHide: function onHide() {
                const legend = chart.get('legendController').legends.top[0];
                legend.setItems(chart.getLegendItems().country);
            }
        });

        chart.scale(metadata.x, {
            range: [0, 1],
        })


        chart.scale(metadata.y, {
            formatter: (val) => {
                if (y.format) return y.format(val);
                return val;
            },
            nice: true,
        });

        chart.axis(metadata.x, {
            label: function label(text, index, total) {
                const textCfg = {};
                if (index === 0) {
                    textCfg.textAlign = 'left';
                } else if (index === total - 1) {
                    textCfg.textAlign = 'right';
                }
                return textCfg;
            }

        });



        chart.area()
            .position(`${metadata.x}*${metadata.y}`)
            .color(metadata.type, y.items ? getColor : null)
            .shape('smooth');

        chart.line()
            .position(`${metadata.x}*${metadata.y}`)
            .color(metadata.type, y.items ? getColor : null)
            .shape('smooth');

        chart.render();
    }, [])

    let { className, titleClassName, title } = props;
    return (
        <div className={`w-100 row no-gutters ${className}`} >
            {title ? <div className={`col-12 c-text-s1 ${titleClassName}`}>{title}</div> : null}
            <canvas className={`col-12 w-100 h-100`} ref={ref}></canvas>
        </div>
    );
}

const AreaChart_P = (props) => {

    const ref = React.useRef(null)


    useEffect(() => {
        let { metadata, x, y, height, getColor, data } = props;

        if (!chart) {
            chart = new Chart({
                container: ref.current,
                autoFit: true,
                height: height,
            });
        }
        chart.data(data);

        //y 轴配置
        chart.scale(metadata.y, {
            formatter: (val) => {
                if (y.format) return y.format(val);
                return val;
            },
            nice: true,

        });



        chart.scale(metadata.x, {
            range: [0, 1],
        })


        chart.tooltip({
            showCrosshairs: true,
            shared: true,
            showTitle: true,

        });



        chart
            .area()
            .position(`${metadata.x}*${metadata.y}`)
            .color(metadata.type, y.items ? getColor : null)
            .shape('smooth')
            .tooltip(false)


        chart
            .line()
            .position(`${metadata.x}*${metadata.y}`)
            .color(metadata.type, y.items ? getColor : null)
            .shape('smooth')
            .tooltip(`${metadata.type}*${metadata.y}`, (name, value) => {
                let item = y.items.find((t) => { return t.type == name });
                return {
                    name,
                    value: item.format ? item.format(value) : value,
                }
            })


        chart.render();

    }, [])

    let { className, title, titleClassName } = props;
    return (
        <div className={`row no-gutters ${className}`}>
            {title ? <div className={`col-12 c-text-s2 mb-3 ${titleClassName}`}>{title}</div> : null}
            <div className={"col-12"} ref={ref}></div>
        </div>
    );
}


export default class AreaChart extends React.Component {


    constructor(props) {
        super(props);
    }


    componentWillReceiveProps(np) {
        let op = this.props;
        if (op != np) {
            let { data } = np;
            if (chart) {
                chart.data(data);
                chart.render();
            }
        }
    }

    getColor(v) {
        let { y } = this.props;
        return y.items.find((t) => { return t.type == v }).color;
    }

    render() {
        let p = {...this.props};
        let m = p.metadata = p.metadata || {};
        m.type = m.type || 'type';
        m.x = m.x || 'x';
        m.y = m.y || 'value';

        return runtime.pc ? <AreaChart_P getColor={(v) => { return this.getColor(v) }} {...p} /> : <AreaChart_M getColor={(v) => { return this.getColor(v) }} {...p} />
    }
}

AreaChart.defaultProps = {
    height: 300,
}

AreaChart.propTypes = {
    y: PropTypes.object.isRequired
};
 */

/*   const data = [
    { period: '第一期', type: "信心指数", value: 0.6 },
    { period: '第一期', type: "进展", value: 0.6 },
    { period: '第二期', type: "信心指数", value: 0.7 },
    { period: '第二期', type: "进展", value: 0.4 },
    { period: '第三期', type: "信心指数", value: 0.2 },
    { period: '第三期', type: "进展", value: 0.8 },
    { period: '第四期', type: "信心指数", value: 0.7 },
    { period: '第四期', type: "进展", value: 0.6 },
  ];
 */

/*
export default class AreaChart extends React.Component {


    constructor(props) {
        super(props);
    }


    formatValue(v, n, p) { //格式化气泡显示数据 - 数值
        let { y } = this.props;
        let items = y.items;
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if ((item.key == n || item.dataKey == n) && item.format) {
                return item.format(v);
            }
        }
        return v;
    }

    formatLabel(v) { //格式化气泡显示数据 - x轴的label
        let { x } = this.props;
        if (x.format) return x.format(v);
        return v;
    }

    mapX(x) {
        var p = { ...x };
        p.dataKey = p.key;
        delete p.key;

        if (p.axis === true) {
            delete p.axis;  //显示指定true，直接移除，因为默认情况下就是显示
        }


        return p;
    }

    mapY(y) {
        var p = { ...y };
        delete p.items;
        if (p.axis === true) {
            delete p.axis;  //显示指定true，直接移除，因为默认情况下就是显示
        }

        return p;
    }

    mapYItem(item) {
        var p = { ...item };
        p.dataKey = p.key;
        delete p.key;

        if (p.color) {
            p.stroke = p.stroke || p.color;
            p.fill = p.fill || p.color;
            delete p.color;
        }

        if (p.linear) {
            p.fillColor = p.fill;
            p.fill = `url(#linear${p.dataKey})`;
        }

        return p;
    }

    renderTitle() {
        let { title, titleClassName } = this.props;
        return <div className={`c-text-sm-s2 c-text-s1 ${titleClassName}`}>{title}</div>
    }
    render() {
        let { data, className, width, height, x, y, titleProps, grid, gridProps } = this.props;
        x = this.mapX(x);
        let items = y.items.map((item) => this.mapYItem(item));
        y = this.mapY(y);
        return (
            <ResponsiveContainer width={width} height={height} className={className}>
                <_AreaChart data={data} margin={{ top: 10, right: 0, bottom: 0 }}>
                    {
                        items.map((item, i) => {
                            var color = item.fillColor;
                            delete item.fillColor;
                            return <defs key={i}>
                                <linearGradient id={`linear${item.dataKey}`} x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor={color} stopOpacity={1} />
                                    <stop offset="95%" stopColor="#FFF" stopOpacity={0.8} />
                                </linearGradient>
                            </defs>
                        })
                    }
                    {x.axis !== false ? <XAxis {...x} /> : null}
                    {y.axis !== false ? <YAxis {...y} /> : null}
                    {grid ? <CartesianGrid {...gridProps} /> : null}
                    <Tooltip formatter={(v, n, p) => { return this.formatValue(v, n, p); }} labelFormatter={(v) => { this.formatLabel(v); }} />
                    <Legend content={() => { return this.renderTitle(); }} {...titleProps}></Legend>
                    {
                        items.map((item, i) => {
                            return <Area key={i} type="monotone" {...item} />
                        })
                    }
                </_AreaChart>
            </ResponsiveContainer>
        )
    }
}

AreaChart.defaultProps = {
    width: "100%",
    height: 300,
    titleProps: { align: "left", verticalAlign: "top", height: 40 },
    gridProps: { strokeDasharray: "0", stroke: "#DCDEDE" },
}

AreaChart.propTypes = {
    x: PropTypes.object.isRequired,
    y: PropTypes.object.isRequired
};
 */
